export { OrderDetailV2ForInsurance } from "./OrderDetailV2ForInsurance";
